// Inline banner for a page-level error/info/success message. SVG icon badge
// matches the rest of the app's design language (Toast, StatTile) instead of emoji.
const STYLES = {
  error: {
    wrap: 'bg-red-50 text-red-700 ring-red-100 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-500/20',
    badge: 'bg-red-100 text-red-600 dark:bg-red-500/20 dark:text-red-300',
  },
  info: {
    wrap: 'bg-blue-50 text-blue-700 ring-blue-100 dark:bg-blue-500/10 dark:text-blue-300 dark:ring-blue-500/20',
    badge: 'bg-blue-100 text-blue-600 dark:bg-blue-500/20 dark:text-blue-300',
  },
  success: {
    wrap: 'bg-green-50 text-green-700 ring-green-100 dark:bg-green-500/10 dark:text-green-300 dark:ring-green-500/20',
    badge: 'bg-green-100 text-green-600 dark:bg-green-500/20 dark:text-green-300',
  },
};
const ICONS = {
  error: (
    <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M10 6v5M10 14h.01" strokeLinecap="round" />
    </svg>
  ),
  info: (
    <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M10 9v5M10 6.5h.01" strokeLinecap="round" />
      <circle cx="10" cy="10" r="7.25" />
    </svg>
  ),
  success: (
    <svg className="h-4 w-4" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
      <path d="M5 10.5l3.5 3.5L15 6.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
};

export function Alert({ type = 'error', children }) {
  const s = STYLES[type] || STYLES.error;
  return (
    <div className={`flex items-start gap-3 rounded-xl px-4 py-3 text-sm ring-1 ${s.wrap}`}>
      <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${s.badge}`}>
        {ICONS[type] || ICONS.error}
      </span>
      <span className="leading-relaxed">{children}</span>
    </div>
  );
}
